import React from 'react'

import ResourceBuilder from 'components/ResourceBuilder'
import Button from 'components/Button'
import { useOpenModal } from 'components/Modal'
import UpgradeAccountModal from 'components/UpgradeAccountModal'
import Icons from 'components/Icons'
import { getAccountData } from 'utils/account'
import { isFeatureEnabled } from 'utils/features'
import { FUNNELS } from 'constants/features'

import usePopupBuilder from './hooks/usePopupBuilder'
import Details from './Details'
import Trigger from './Trigger'
import Template from './Template'
import Review from './Review'

export default function PopupBuilder({
  initialPopup,
  close,
  initialActiveScreen,
}) {
  const builder = usePopupBuilder({
    initialPopup,
    initialActiveScreen,
  })

  const ActiveScreenComponent =
    SCREEN_NAME_TO_COMPONENT_MAP[builder.activeScreen.name]

  return (
    <ResourceBuilder
      close={close}
      builder={builder}
      resource={builder.popup}
      initialActiveScreen={initialActiveScreen}
      PrimaryCTA={PrimaryCTA}
      SecondaryCTA={SecondaryCTA}
      ActiveScreenComponent={ActiveScreenComponent}
    />
  )
}

function PrimaryCTA({ builder, rb }) {
  const {
    activeScreen,
    savingButton,
    setSavingButton,
    saveNextHandler,
    publishHandler,
  } = builder
  const isReviewScreen = activeScreen.name === 'review'
  const accountData = getAccountData()
  const canPublish = isFeatureEnabled(accountData, FUNNELS)
  const openModal = useOpenModal()

  if (isReviewScreen) {
    return (
      <Button
        variant="solid"
        loading={savingButton === 'publish'}
        disabled={!!savingButton}
        onClick={async () => {
          if (canPublish) {
            if (!savingButton) {
              setSavingButton('publish')
              try {
                await publishHandler()
              } catch (err) {}
              setSavingButton(null)
            }
          } else {
            openModal(
              <UpgradeAccountModal
                featureToEnable={FUNNELS}
                account={{ data: accountData }}
              />
            )
          }
        }}
      >
        <div className="flex flex-row items-center justify-start">
          {!canPublish && (
            <Icons.Lock className="w-3 mr-2 text-white fill-current" />
          )}
          Publish Now
        </div>
      </Button>
    )
  }
  return (
    <Button
      variant="solid"
      loading={savingButton === 'saveAndNext'}
      disabled={!!savingButton}
      onClick={async () => {
        if (!savingButton) {
          setSavingButton('saveAndNext')
          try {
            await saveNextHandler()
          } catch (err) {}
          setSavingButton(null)
        }
      }}
    >
      Save & Next
    </Button>
  )
}

function SecondaryCTA({ builder, rb }) {
  const { activeScreen, savingButton, setSavingButton, saveHandler } = builder
  const isReviewScreen = activeScreen.name === 'review'

  if (isReviewScreen) {
    return (
      <Button variant="bordered" className="mr-4" onClick={rb.close}>
        Close
      </Button>
    )
  }

  return (
    <Button
      variant="bordered"
      className="mr-4"
      loading={savingButton === 'save'}
      disabled={!!savingButton}
      onClick={async () => {
        if (!savingButton) {
          setSavingButton('save')
          try {
            await saveHandler()
          } catch (err) {}
          setSavingButton(null)
        }
      }}
    >
      Save
    </Button>
  )
}

const SCREEN_NAME_TO_COMPONENT_MAP = {
  details: Details,
  trigger: Trigger,
  template: Template,
  review: Review,
}
